import { FC } from 'react';

import BaseNavigationHeader from 'components/NavigationHeader';

interface NavigationHeaderProps {
  backTo?: string;
}

const NavigationHeader: FC<NavigationHeaderProps> = ({ backTo }) => (
  <BaseNavigationHeader backTo={backTo} closeTo="/cards" />
);

export default NavigationHeader;
